module.exports = __webpack_public_path__ + "img/bell.8cb2fe58.png";